// extracted by mini-css-extract-plugin
module.exports = {"notes":"SyncJbcSettings__notes--3jVUP","innerNotes":"SyncJbcSettings__innerNotes--2UaHo"};